module.exports = __webpack_public_path__ + "5b9ff36c7fed044c253162373820d80a.svg";